import { Modal, ThemeProvider, createTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { billsFileDataState, billsFileModalOpenState } from "../../../atoms/myWallet";
import { useCallback } from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const theme = createTheme({
  components: {
    MuiModal: {
      styleOverrides: {
        root: {
          margin: "20px",
          overflow: "auto",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          display: "flex",
          alignItems: "center",
          gap: "10px",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: "14px",
          opacity: 0.8,
        },
      },
    },
  },
});

const BillsFileModal = () => {
  const [billsFileModalOpen, setBillsFileModalOpen] = useRecoilState(billsFileModalOpenState);
  const [billsFileData, setBillsFileData] = useRecoilState(billsFileDataState);

  const handleClose = useCallback(() => {
    setBillsFileModalOpen(false);
    setBillsFileData("");
  }, [setBillsFileModalOpen, setBillsFileData]);

  return (
    <ThemeProvider theme={theme}>
      <Modal open={billsFileModalOpen} onClose={handleClose}>
        <div
          style={{
            backgroundColor: "var(--lighterBg)",
            borderRadius: "var(--inputBorderRadius)",
            padding: "20px",
            outline: 0,
            display: "grid",
            gap: "var(--gap)",
            width: "100%",
            maxWidth: "1100px",
            margin: "auto",
            position: "relative",

            maxHeight: "90vh",
            overFLowY: "auto",
          }}
        >
          <CancelOutlinedIcon
            sx={{
              position: "absolute",
              right: 1,
              top: 1,
              cursor: "pointer",
              color: "var(--priceText)",
              transition: "all 80ms linear",
              ":hover": {
                color: "var(--notRed)",
                transition: "all 80ms linear",
              },
            }}
            onClick={handleClose}
          />
          <div dangerouslySetInnerHTML={{ __html: billsFileData }} />
        </div>
      </Modal>
    </ThemeProvider>
  );
};

export default BillsFileModal;
